import { gql } from '@apollo/client';

export const GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM = gql`
  query GetTagesDaten($standortIds: [String!]!, $zeitraum: ZeitraumInput!) {
    termine_termineKalenderByStandortIdAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      id
      kalenderSchluessel
      name
      idStandort
      termine(standortIds: $standortIds, zeitraum: $zeitraum) {
        id
        standortId
        titel
        datum
        beginn
        ende
        terminKalenderId
        image {
          name
          contentType
          url
          thumbnailUrl
        }
        markierung
        termineDetails {
          beschreibung
          specials
        }
        wiederholung
        wiederholungBis
      }
    }
    termine_feiertageByStandortIdsAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      name
      datum
    }
  }
`;
